import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  padding: 0 24px 24px 24px;

  .ant-btn-default {
    padding: 8px 16px;
    font-weight: 500;
  }
`;
